export const CATERING_HOME = '/dashboard'
export const CATERING_LEADS = '/leads'
export const CATERING_AGENT_SETTINGS = '/agent-settings'

export const CATERING_ONLY_ROUTES = [CATERING_HOME, CATERING_LEADS, CATERING_AGENT_SETTINGS]

export const CATERING_ROUTE_ALLOWLIST = [
  ...CATERING_ONLY_ROUTES,
  '/orders',
  '/order',
  '/messages',
  '/lists',
  '/profile',
  '/users/roles',
  '/roles',
  '/guides',
  '/locked',
  '/settings',
  '/catering',
  '/sell',
  '/store/stores',
  '/store/products',
  '/store/discount-codes',
  '/store/account-credits',
  '/store/loyalty-program',
  '/store/referral-program',
  '/store/fulfillment-methods'
]

export const FRANCHISE_HOME = '/dashboard'

export const FRANCHISE_ROUTE_ALLOWLIST = [
  FRANCHISE_HOME,
  '/store/products',
  '/availability',
  '/lists',
  '/order',
  '/franchise/account'
]

export function matchesRouteBase(path, base) {
  return path === base || path.startsWith(base + '/')
}

export function canAccessRouteForPlatform(path, platform) {
  if (platform === 'franchise') {
    return FRANCHISE_ROUTE_ALLOWLIST.some(base => matchesRouteBase(path, base))
  }
  if (platform === 'catering') {
    return CATERING_ROUTE_ALLOWLIST.some(base => matchesRouteBase(path, base))
  }
  return !CATERING_ONLY_ROUTES.some(base => matchesRouteBase(path, base))
}

export function defaultRouteForPlatform(platform, ecommerceDefault) {
  if (platform === 'catering') return CATERING_HOME
  if (platform === 'franchise') return FRANCHISE_HOME
  return ecommerceDefault
}

export function platformsFromAttributes(attributes) {
  if (Array.isArray(attributes?.platforms) && attributes.platforms.length) {
    return attributes.platforms
  }
  return ['ecommerce']
}

export function resolveActivePlatform(stored, platforms) {
  if (stored && platforms.includes(stored)) {
    return stored
  }
  if (platforms.includes('ecommerce')) {
    return 'ecommerce'
  }
  return platforms[0]
}
